import HCLTreeVertex from "../HCLTreeNode/HCLTreeVertex";
import { addClonedCells } from "../../components/Model/SingleHCLModelView/SingleTreeView/Tools/Utils";
import {mxCell, mxClient, mxClipboard, mxEvent, mxKeyHandler} from "mxgraph-js";

class HCLTreeMxGraphKeyHandler {

  public static KEY_STROKES = {
    DELETE: [46, 8],
    COPY: [67],
    PASTE: [86],
    CUT: [88],
    SELECT: [65],
  };

  public static getPressedKey() {
    document.onkeypress = (evt) => {
      console.log(`onkeypress  - ${evt.key} was pressed!`);
    };

    document.onkeyup = (evt) => {
      console.log(`onkeyup - ${evt.key} was pressed!`);
    };

    document.onkeydown = (evt) => {
      console.log(`onkeydown - ${evt.key} was pressed!`);
    };
  }

  // allows for use of cmd(mac) or ctrl(windows)
  public static allowCTRLAndCMD(keyHandler: mxKeyHandler) {
    keyHandler.getFunction = (evt: any) => {
      if (evt != null) {
        // @ts-ignore
        return (mxEvent.isControlDown(evt) || (mxClient.IS_MAC && evt.metaKey)) ? keyHandler.controlKeys[evt.keyCode] : keyHandler.normalKeys[evt.keyCode];
      }
      return null;
    };
  }

  // deletes node
  public static bindDeleteKey(keyHandler: mxKeyHandler) {
    (HCLTreeMxGraphKeyHandler.KEY_STROKES.DELETE).forEach((k) => {
      keyHandler.bindKey(k, (evt: any) => {
        // @ts-ignore
        const cells = keyHandler.graph.getSelectionCells();
        cells.forEach((cell: mxCell) => {
          if(cell.edge) {
            // @ts-ignore
            keyHandler.graph.removeCells([cell]);
          } else if (cell instanceof HCLTreeVertex) {
            // @ts-ignore
            keyHandler.graph.removeVertex(cell);
          } else {
            console.error("MxCell not of type HCLTreeVertex, not removing");
          }
        });
      });
    });
  }

  // clears selected key
  public static bindEscKey(keyHandler: mxKeyHandler) {
    keyHandler.escape = (evt: any) => {
      // @ts-ignore
      keyHandler.graph.getSelectionModel().clear();
    };
  }

  //copying cells
  public static bindCKey(keyHandler: mxKeyHandler) {
    (HCLTreeMxGraphKeyHandler.KEY_STROKES.COPY).forEach(key => {
      keyHandler.bindControlKey(key, (evt: any) => {
        // @ts-ignore
        const cells = keyHandler.graph.getSelectionCells();
        mxClipboard.setCells(cells);
      })
    })
  }

  //pasting cells
  public static bindVKey(keyHandler: mxKeyHandler) {
    (HCLTreeMxGraphKeyHandler.KEY_STROKES.PASTE).forEach(key => {
      keyHandler.bindControlKey(key, (evt: any) => {
        const cells = mxClipboard.getCells();
        // @ts-ignore
        addClonedCells(cells, keyHandler.graph);
      })
    })
  }

  //selecting all cells
  public static bindAKey(keyHandler: mxKeyHandler) {
    (HCLTreeMxGraphKeyHandler.KEY_STROKES.SELECT).forEach(key => {
      keyHandler.bindControlKey(key, (evt: any) => {
        // @ts-ignore
        keyHandler.graph.setSelectionCells(keyHandler.graph.getChildCells(keyHandler.graph.getDefaultParent(), true, true));
      })
    })
  }

  //cutting cells
  public static bindXKey(keyHandler: mxKeyHandler) {
    (HCLTreeMxGraphKeyHandler.KEY_STROKES.CUT).forEach(key => {
      keyHandler.bindControlKey(key, (evt: any) => {
        // @ts-ignore
        const cells = keyHandler.graph.getSelectionCells();
        mxClipboard.setCells(cells);
        cells.forEach((cell: any) => {
          if (cell.edge) {
            // @ts-ignore
            keyHandler.graph.removeCells([cell]);
          } else if (cell instanceof HCLTreeVertex) {
            // @ts-ignore
            keyHandler.graph.removeVertex(cell);
          }
        });
      })
    })
  }
}

export default HCLTreeMxGraphKeyHandler;
